<template>
    <transition name="fade">
    <div v-if="show_field" class="customer-custom-history-field col-12">
        <label v-if="field.type != 'html'" class="customer-custom-history-field__label" :for="'field_' + field.id">
            {{ field.description }}
        </label>
        <div v-else v-html="field.description">
        </div>
        <input :value="value" v-if="editable_type" :id="'field_' + field.id" :type="editable_type" class="form-control"
            @input="handleInput" :placeholder="placeholder" :required="required">
        <textarea :value="value" v-else-if="field.type == 'textarea'" class="form-control" :id="'field_' + field.id"
            @input="handleInput" :placeholder="placeholder" :required="required"></textarea>
        <div v-else-if="field.type == 'checkbox'">
            <div class="form-check form-check-inline" v-for="(val, key) in field.options.values"
                :key="`${field.slug}_${key}`">
                <input type="checkbox" :checked="value[`${field.slug}_${key}`]" class="form-check-input"
                    :id="`${field.slug}_${key}`" value="true" @input="handleInput">
                <label :for="`${field.slug}_${key}`" class="form-check-label">{{ val }}</label>
            </div>
        </div>
        <div v-else-if="field.type == 'radio'">
            <div class="form-check form-check-inline" v-for="(val, key) in field.options.values"
                :key="`${field.slug}_${key}`">
                <input type="radio" :required="required" :checked="value == key" :name="field.slug" class="form-check-input"
                    :id="`${field.slug}_${key}`" :value="key" @input="handleInput">
                <label :for="`${field.slug}_${key}`" class="form-check-label">{{ val }}</label>
            </div>
        </div>
        <div v-else-if="field.type == 'select'">
            <select v-model="value" :required="required" :name="field.slug" :id="'field_' + field.id" class="custom-select"
                @input="handleInput">
                <option>{{ placeholder }}</option>
                <option v-for="(val, key) in field.options.values" :value="key" :key="key">
                    {{ val }}
                </option>
            </select>
        </div>
    </div>
    </transition>
</template>

<script>
export default {
    props: ['section', 'section_data', 'field', 'value'],
    data() {
        return {
            content: this.value,
        };
    },
    computed: {
        show_field() {
            if (!this.field || !this.field.options || !this.field.options.show_cond) return true;
            for (const slug in this.field.options.show_cond) {
                let expected_value = this.field.options.show_cond[slug];
                let actual_value = this.section_data[slug] ? this.section_data[slug] : null;

                if (actual_value === null || actual_value != expected_value) {
                    return false;
                }
            }
            return true;
        },
        required() {
            return false;
        },
        placeholder() {
            return this.field.options.placeholder || '';
        },
        editable_type() {
            const types = {
                "date": "date",
                "datetime": "datetime",
                "text": "text",
                "number": "number",
                "email": "email",
                "tel": "tel",
            }

            return types[this.field.type] || null;
        },
    },
    methods: {
        handleInput(e) {
            switch (this.field.type) {
                case 'checkbox':
                    let val = {
                        'name': e.target.id,
                        'value': e.target.checked
                    };
                    this.$emit('input', val);
                    break;
                default:
                    this.$emit('input', e.target.value);
            }
        }
    },
    mounted() {
    }
}
</script>

<style lang="scss">
.customer-custom-history-field {
    &__label {
        font-weight: 600;
    }
}
</style>